// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import zenscroll from 'zenscroll'
import { DateTime } from 'luxon'

// Internal Dependencies:
import Schedule from 'components/Schedule/Schedule'
import Calendar from 'components/Form/Calendar'
import Checkbox from 'components/Form/Checkbox'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { toggleAccountDropdown } from 'actions/site'
import { getFullScheduleData, goToTrack } from 'actions/schedule'

class SchedulePage extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			isLoading: false,
			changedDay: false,
			showCalendar: false,
			currentDateTime: DateTime.local(),
			currentJsDate: DateTime.local().toJSDate(),
			minimumDate: DateTime.local().minus( { days: 30 } ).toJSDate(),
			maximumDate: DateTime.local().plus( { days: 2 } ).toJSDate(),
			selectedWeekDay: DateTime.local().toFormat( 'EEE' ),
			selectedWeekDayNumber: DateTime.local().toFormat( 'c' ), // Monday is first.
			selectedMonth: DateTime.local().toFormat( 'MM' ),
			selectedMonthRendered: DateTime.local().toFormat( 'LLLL' ),
			selectedDay: DateTime.local().toFormat( 'dd' ),
			maxSelectedDateTime: DateTime.local().plus( { days: 2 } ),
			maxDayReached: false,
			week: [],
			showNotice: false,
			noticeText: '',
			showShort: false
		}

		this.state = state
	}

	componentDidMount() {
		const { nowPlaying } = this.props

		this._ismounted = true
		document.documentElement.classList.add( 'html-page-schedule' )

		this.updateWeekData()
	}

	componentWillUnmount() {
		this._ismounted = false
		document.documentElement.classList.remove( 'html-page-schedule' )
	}

	componentDidUpdate( prevProps ) {

	}

	updateWeekData = () => {
		const { selectedMonth, selectedDay, maxSelectedDateTime } = this.state
		let maxDayReached = false

		const selectedDateTime = DateTime.fromFormat( `${selectedMonth} ${selectedDay}`, 'MM dd' )
		const endDay = selectedDateTime.plus( { days: 2 } )
		let startDay = selectedDateTime.minus( { days: 4 } )

		// If a later date than the max is selected, use the max:
		if ( maxSelectedDateTime < endDay ) {
			startDay = maxSelectedDateTime.minus( { days: 6 } ),
			maxDayReached = true
		}

		let week = []

		for ( var i = -1; i++ < 6; ) {
			let thisDate = startDay.plus( { days: i } )

			week.push(
				{
					'day': thisDate.toFormat( 'dd' ),
					'dayRendered': thisDate.toFormat( 'd' ),
					'weekDay': thisDate.toFormat( 'EEE' ),
					'weekDayNumber': thisDate.toFormat( 'c' ),
					'month': thisDate.toFormat( 'MM' ),
					'monthRendered': thisDate.toFormat( 'LLL' ),
				}
			)
		}

		this.setState( {
			week: week,
			maxDayReached: maxDayReached
		} )
	}

	handleStationChangeClick = () => {
		this.props.toggleAccountDropdown()

		this.scheduleProgramsWrapRef.scrollTo( { y: 0 } )
	}

	handlePreviousWeekClick = () => {
		const { selectedDay, selectedMonth } = this.state

		// Update the selected day:
		const newDateTime = DateTime.fromFormat( `${selectedMonth} ${selectedDay}`, 'MM dd' ).minus( { days: 7 } )

		this.updateSelectedDay( newDateTime )
	}

	handleNextWeekClick = () => {
		const { selectedDay, selectedMonth } = this.state

		// Update the selected day:
		const newDateTime = DateTime.fromFormat( `${selectedMonth} ${selectedDay}`, 'MM dd' ).plus( { days: 7 } )

		this.updateSelectedDay( newDateTime )
	}

	handleWeekDayClick = ( e ) => {
		const { fullSchedule, getFullScheduleData } = this.props
		const weekDay = e.currentTarget.getAttribute( 'data-week-day' )
		const weekDayNumber = e.currentTarget.getAttribute( 'data-week-day-number' )
		const day = e.currentTarget.getAttribute( 'data-day' )
		const month = e.currentTarget.getAttribute( 'data-month' )
		const monthRendered = e.currentTarget.getAttribute( 'data-month-rendered' )

		getFullScheduleData( day, month )

		const newDateTime = DateTime.fromFormat( `${month} ${day}`, 'MM dd' ).plus( { days: 7 } )

		this.setState( {
			changedDay: true,
			currentDateTime: newDateTime,
			currentJsDate: newDateTime.toJSDate(),
			selectedWeekDay: weekDay,
			selectedWeekDayNumber: weekDayNumber,
			selectedMonth: month,
			selectedMonthRendered: monthRendered,
			selectedDay: day
		} )
	}

	updateSelectedDay = ( newDateTime ) => {
		const { getFullScheduleData } = this.props
		const { maxSelectedDateTime } = this.state

		// If a later date than the max is selected, use the max:
		if ( maxSelectedDateTime < newDateTime ) {
			newDateTime = maxSelectedDateTime
		}

		const selectedDay = newDateTime.toFormat( 'dd' )
		const selectedMonth = newDateTime.toFormat( 'MM' )

		this.setState( {
			currentDateTime: newDateTime,
			currentJsDate: newDateTime.toJSDate(),
			selectedWeekDay: newDateTime.toFormat( 'EEE' ),
			selectedWeekDayNumber: newDateTime.toFormat( 'c' ),
			selectedMonth: selectedMonth,
			selectedMonthRendered: newDateTime.toFormat( 'LLLL' ),
			selectedDay: selectedDay
		} )

		// Get schedule data:
		getFullScheduleData( selectedDay, selectedMonth )

		// Wait for the state updates (above) before this next state update:
		setTimeout( () => {
			this.updateWeekData()
		}, 100 )
	}

	showCalendar = () => {
		this.setState( {
			showCalendar: true
		} )
	}

	hideCalendar = () => {
		this.setState( {
			showCalendar: false
		} )
	}

	handleCalendarDateChange = ( id, value ) => {
		// Update the selected day:
		const newDateTime = DateTime.fromJSDate( value )

		this.updateSelectedDay( newDateTime )
	}

	handleShowShort = () => {
		this.setState( {
			showShort: true
		} )
	}

	handleHideShort = () => {
		this.setState( {
			showShort: false
		} )
	}

	setNotice = ( text ) => {
		this.setState( {
			showNotice: true,
			noticeText: text
		} )

		setTimeout( () => {
			this.setState( {
				showNotice: false
			} )
		}, 4000 )
	}

	renderHeaderNavMobile() {
		const { selectedWeekDay, selectedMonthRendered, selectedDay } = this.state

		if ( ! selectedWeekDay ) {
			return null
		}

		return (
			<div className="schedule-calendar-button" onClick={ this.showCalendar }>
				<div className="-icon">
					<i className="icon-calendar"></i>
				</div>

				<div className="-text">{ `${selectedWeekDay}, ${selectedMonthRendered} ${selectedDay}` }</div>
			</div>
		)
	}

	renderHeaderNav() {
		const { week, maxDayReached, selectedWeekDay, selectedMonthRendered, selectedMonth, selectedDay } = this.state
		const nextClass = maxDayReached ? '-next is-disabled' : '-next'

		if ( ! selectedWeekDay ) {
			return null
		}

		const daysMarkup = week.map( ( weekData ) => {
			let className = weekData.weekDay == selectedWeekDay ? '-week-day is-selected' : '-week-day'
			let date = ''
			let dateText = ''

			if ( weekData.weekDay == selectedWeekDay ) {
				dateText = `${selectedMonthRendered} ${selectedDay}`
			} else {
				date = selectedDay
			}

			return (
				<div
					className={ className }
					onClick={ this.handleWeekDayClick }
					data-week-day={ weekData.weekDay }
					data-week-day-number={ weekData.weekDayNumber }
					data-day={ weekData.day }
					data-month={ weekData.month }
					data-month-rendered={ weekData.monthRendered }
					key={ weekData.weekDay }
				>
					<div className="-week-day-day">{ weekData.weekDay }</div>
					<div className="-week-day-date">{ `${weekData.monthRendered} ${weekData.dayRendered}` }</div>
				</div>
			)
		})

		return (
			<div className="schedule-week-nav-wrap">
				<div className="-previous" onClick={ this.handlePreviousWeekClick }>
					<i className="icon-chevron-right" aria-hidden="true"></i>
				</div>

				<div className="-week-days">
					{ daysMarkup }
				</div>

				<div className={ nextClass } onClick={ this.handleNextWeekClick }>
					<i className="icon-chevron-right" aria-hidden="true"></i>
				</div>
			</div>
		)
	}

	render() {
		const { fullSchedule, siteId, stationsById, timezoneType, page } = this.props
		const { isLoading, showCalendar, showNotice, noticeText, currentDateTime, currentJsDate, minimumDate, maximumDate, selectedDay, selectedWeekDay, selectedMonth, showShort } = this.state
		const stationScheduleText = 'AICE' == siteId || 'AVST' == siteId ? 'Schedule' : ' Schedule'

		return (
			<div className="schedule-wrap">
				{ ( siteId && ( isLoading || ! fullSchedule ) ) &&
					<LoadingSpinner />
				}

				{ noticeText &&
					<div className={ siteNoticeClass }>
						<p>{ noticeText }</p>
					</div>
				}

				{ showCalendar &&
					<div className="schedule-calendar">
						<div className="-inner">
							<Calendar
								id=""
								value={ currentJsDate }
								onChange={ this.handleCalendarDateChange }
							/>

							<i className="icon-close" onClick={ this.hideCalendar } />
						</div>
					</div>
				}

				{ ! siteId &&
					<div className="-station-prompt" onClick={ this.handleStationChangeClick }>
						Click here to set your station
					</div>
				}

				<div className="-settings-wrap">
					{ fullSchedule && siteId && stationsById && stationsById[ siteId ] &&
						<div className="-station" onClick={ this.handleStationChangeClick }>
							<div className="-text">
								<div className="-name">
									{ stationsById[ siteId ].name } { stationsById[ siteId ].freq_fm } Schedule

									&nbsp;
									<span className="-timezone">
										{ 'user' == timezoneType &&
											'(my timezone)'
										||
											'(station timezone)'
										}
									</span>
								</div>

								<div className="-change">Click to change</div>
							</div>
						</div>
					}

					<div className="-settings">
						{ fullSchedule && this.renderHeaderNavMobile() }

						{ showShort &&
							<div className="button -show-short-button" onClick={ this.handleHideShort }>
								<span className="schedule-toggle-icon has-visible"><i className="icon-chevron-left"></i><i className="icon-chevron-right"></i></span> <span>Hide</span>
							</div>
						||
							<div className="button -show-short-button" onClick={ this.handleShowShort }>
								<span className="schedule-toggle-icon"><i className="icon-chevron-left"></i><i className="icon-chevron-right"></i></span> <span>Show all</span>
							</div>
						}
					</div>
				</div>

				{ fullSchedule && this.renderHeaderNav() }

				{ ! isLoading &&
					<div id="js-schedule-programs-wrap" className="schedule-programs-wrap">
						<Schedule
							dateTime={ currentDateTime }
							selectedDay={ selectedDay }
							selectedWeekDay={ selectedWeekDay }
							selectedMonth={ selectedMonth }
							showBeforeNow={ true }
							showAfterNow={ true }
							showShort={ showShort }
						/>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		page: state.page.selected,
		fullSchedule: state.schedule.fullSchedule,
		programsById: state.programs.byId,
		nowPlaying: state.schedule.nowPlaying,
		mediaError: state.schedule.mediaError,
		timezone: state.schedule.timezone,
		timezoneOffset: state.schedule.timezoneOffset,
		timezoneType: state.schedule.timezoneType,
		siteId: state.schedule.siteId,
		stationsById: state.schedule.stationsById,
		selectedItem: state.schedule.selectedItem,
		rewindMaxHours: state.schedule.rewindMaxHours,
		allowFutureFastForward: state.schedule.allowFutureFastForward,
		accountDropdownIsOpen: state.site.accountDropdownIsOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getFullScheduleData( day, month, daysOffset, daysOffsetDirection ) {
			dispatch( getFullScheduleData( day, month, daysOffset, daysOffsetDirection ) )
		},

		toggleAccountDropdown() {
			dispatch( toggleAccountDropdown() )
		},

		goToTrack( key ) {
			dispatch( goToTrack( key ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( SchedulePage )
